import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  private readonly notification = inject(NotificationService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((errorResp: HttpErrorResponse) => {
        // /user liefert 401, solange niemand angemeldet ist - dafür keine Fehlermeldung zeigen.
        if (!(errorResp.error instanceof ErrorEvent) && !request.url.endsWith('user')) {
          this.notification.showError(this.toMessage(errorResp));
        }
        return throwError(() => errorResp);
      })
    );
  }

  private toMessage(errorResp: HttpErrorResponse): string {
    return errorResp.error?.message || errorResp.error?.Error || errorResp.message;
  }
}
